module.exports = __webpack_public_path__ + "img/olympic-tennis.5fe9748c.png";